import React, { Component } from 'react';

export default class Spinner extends Component {

	render () {
		return (
			<div className="spinner">
				<i className="fa fa-spinner fa-spin"></i>
			</div>
		);
	}
}
